import { apiAxios } from "@helpers/lib/axios";
import { API_ENDPOINTS } from "@memorang/constants/urls";
import { randomUUID } from "expo-crypto";
import type { ExternalAuthResponse } from "./types";

export const handleExternalAuth = async ({
	token,
	platform,
	tenantId,
}: {
	token: string;
	platform?: string;
	tenantId?: string;
}): Promise<ExternalAuthResponse> => {
	// TODO(backend): verify inbound JWT signature against tenant Clerk JWKS;
	// validate issuer/audience/expiry; cache jti/sid server-side for replay protection.
	const { data } = await apiAxios.post(API_ENDPOINTS.COMMERCE_AUTH_EXTERNAL, {
		token,
		platform,
		provider: "clerk",
		tenantId,
		nonce: randomUUID(),
	});

	return data;
};
